import React, { FC } from 'react';

import { Icon } from './PremiumLabel.styled';

export interface PremiumLabelProps {
  /**
   * Indicates whether the feature to which it refers is available to the user
   */
  isPremium?: boolean;
}

const PremiumLabel: FC<PremiumLabelProps> = ({ isPremium = false }) => {
  return <Icon data-cy="premiumLabel" $isPremium={isPremium} />;
};

export default PremiumLabel;
